import { FC } from 'react';
import { twJoin } from 'tailwind-merge';

import { LineageView } from '@/components/Lineage/LineageView';
import { DetailsSection } from '@/components/SectionWithCard';

type LineageSectionProps = {
  fqn: string | undefined | null;
  highlightedUniqueIds: string[];
  onRenderComplete?: () => void;
  size?: 'small' | 'large' | 'xl';
};

export const LineageSection: FC<LineageSectionProps> = ({
  highlightedUniqueIds,
  onRenderComplete,
  fqn,
  size = 'large',
}) => {
  return (
    <DetailsSection heading="Lineage" isCompact={true}>
      <div
        className={twJoin(
          size === 'small' && 'h-72',
          size === 'large' && 'h-96',
          size === 'xl' && 'h-[480px]',
        )}
      >
        <LineageView
          fqn={fqn}
          highlightedUniqueIds={highlightedUniqueIds}
          onRenderComplete={onRenderComplete}
        />
      </div>
    </DetailsSection>
  );
};
